import { InterestOnlyType } from '@willow/graphql-iso/src/app';

export const formatInterestOnlyType = (type: InterestOnlyType): string => {
  switch (type) {
    case InterestOnlyType.Actual_360:
      return 'Actual/360';
    case InterestOnlyType.Actual_365:
      return 'Actual/365';
    case InterestOnlyType.Thirty_360:
      return '30/360';
    default:
      return 'N/A';
  }
};
